import { PurchasePopUp } from './PurchasePopUp';

export default PurchasePopUp;
